var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92651 1C12.0058 2.83696 14.7196 3.79339 17.4929 3.66667C17.8967 5.03824 18.0202 6.47686 17.8562 7.89705C17.6922 9.31724 17.2439 10.69 16.5381 11.9338C15.8323 13.1776 14.8833 14.267 13.7475 15.1373C12.6117 16.0076 11.3123 16.6411 9.92651 17C8.54072 16.6411 7.24133 16.0076 6.10554 15.1373C4.96975 14.267 4.02075 13.1776 3.31493 11.9338C2.60911 10.69 2.16087 9.31724 1.99685 7.89705C1.83283 6.47686 1.95638 5.03824 2.36015 3.66667C5.13347 3.79339 7.84725 2.83696 9.92651 1Z",
    stroke: "#565C63",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92654 9.00043C9.69045 9.00043 9.46404 8.90678 9.2971 8.74008C9.13016 8.57339 9.03638 8.34729 9.03638 8.11155C9.03638 7.8758 9.13016 7.6497 9.2971 7.48301C9.46404 7.31631 9.69045 7.22266 9.92654 7.22266C10.1626 7.22266 10.389 7.31631 10.556 7.48301C10.7229 7.6497 10.8167 7.8758 10.8167 8.11155C10.8167 8.34729 10.7229 8.57339 10.556 8.74008C10.389 8.90678 10.1626 9.00043 9.92654 9.00043ZM9.92654 9.00043V11.2227",
    stroke: "#565C63",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinicon);
export default __webpack_public_path__ + "static/media/pinicon.194bf3179767ccb33a122cad57647478.svg";
export { ForwardRef as ReactComponent };